// Card #1797 — the Blank mode type's logo source is a COMMITTED BRAND
// ASSET, not `Show.logoKey` (#1058)'s S3 upload path and not view/show/org
// config (design decision on the card, superseding this repo's earlier
// working assumption in packages/brand/venues/README.md that #1797 would
// wire up to logoKey — it does not).
//
// Card #2308 (bug #211) — the original version of this file resolved a
// mode's `logoAsset` through a small HARDCODED key->image map
// (`BLANK_LOGO_ASSETS`), which is exactly how "WEC (vertical, white)" ended
// up offered to every org regardless of who they are. That map, and the
// venue-asset import it needed, are gone. `mode.logoAsset` is now the id of
// one of the SIGNED-IN ORG's own uploaded brand assets (ModeEditorDialog.jsx
// / score-api's BRAND_ASSET table); score-api's public scoreboard route
// resolves that id into a real (presigned, org-scoped) URL server-side —
// scoreboard-public.js's `resolveBlankLogoAssetUrl`, tenant-interlocked on
// orgId — and hands it down as `mode.logoAssetUrl`.
//
// Card #2311 (PROD HOTFIX, 2026-09-05, Jaybill): "the Fox Village mark must
// NEVER appear on a themed board, under any circumstance. There is no
// last-resort FV fallback any more." This file used to end its chain with
// packages/brand/logo/fox-village-mark-white.svg (see git history for that
// era's reasoning about square-vs-portrait artwork, which is moot now — the
// asset itself is gone from this file). The chain is now exactly two steps,
// then NOTHING:
//   1. the mode's own server-resolved logoAssetUrl (score-api: the Blank
//      mode's stored pick, already folded with step 2 below when it's the
//      literal Blank mode type — see resolveBlankLogoUrl there)
//   2. the view's theme's own logo (`theme.logos`, first slot with a url —
//      same "most prominent configured logo" pick score-api's
//      resolveBlankLogoUrl makes, done again here so this ALSO covers the
//      cases score-api cannot attach a theme fallback to `mode` for: `mode`
//      itself is `null` (no mode picked yet / a broken mirror chain) or the
//      render never reached a successful poll at all (ScoreboardFrame's
//      isLoading state, ScoreboardErrorBoundary catching a throw before any
//      `mode` exists).
//   3. nothing — an empty logo area is CORRECT and preferred over showing
//      Fox Village's own mark on someone else's branded board.
export function themeLogoUrlOf(theme) {
  const logos = Array.isArray(theme?.logos) ? theme.logos : [];
  return logos.find((logo) => logo?.url)?.url ?? null;
}

// Resolves a mode's (server-resolved) `logoAssetUrl` to an image src, or
// `null` if nothing on the whole chain resolves. Never throws: a
// falsy/empty/non-string logoAssetUrl simply falls through to the theme
// logo, then to `null` — never a hardcoded brand mark. Callers must treat a
// `null` return as "render no logo," not as license to substitute their
// own default.
export function resolveBlankLogoAsset(logoAssetUrl, theme) {
  return logoAssetUrl || themeLogoUrlOf(theme) || null;
}
